/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import Container from 'components/Container';
import React, { Fragment } from 'react';

export interface DownloadsItemsProps extends React.HTMLAttributes<HTMLDivElement> {
  downloads: Map<string, { description: string; href: string; name: string; title: string }[]>
}

const DownloadsItems: React.FC<DownloadsItemsProps> = ({ downloads }) => {
  return (<ClassNames>
    {({ theme }) =>
      <Container maxWidth="lg">
        <div
          css={{
            '@media (min-width: 425px)': {},
            '@media (min-width: 600px)': {},
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'flex-start',
            padding: theme.spacing(4, 0),
          }}
        >
          {Object.entries(downloads).map(([groupName, dnd], idx) => <DownloadsGroup key={idx} downloadItems={dnd} groupName={groupName} />)}
        </div>
      </Container>}
  </ClassNames>);
}

const DownloadsGroup: React.FC<{ downloadItems: { description: string; href: string; name: string; title: string }[], groupName: string }> =
  ({ groupName, downloadItems }) => {
    return (
      <ClassNames>
        {({ theme }) => (
          <Fragment>
            <div css={{ marginBottom: theme.spacing(2) }}>
              {groupName}
            </div>
            {downloadItems.map((file, ix) => (
              <DownloadFile key={ix} file={file} />
            ))}
          </Fragment>
        )}
      </ClassNames>
    );
  }

const DownloadFile: React.FC<{ file: { description: string; href: string; name: string; title: string } }> =
  ({ file }) => {
    return (
      <ClassNames>
        {({ theme }) => (
          <span
            css={{
              color: theme.palette.text.primary,
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              padding: theme.spacing(1, 2),
              textDecoration: 'none',
              transition: 'all .2s ease',
              width: '100%',

            }}>
            <a
              href={file.href}
              title={file.title}
              css={{
                '&:hover': {
                  background: theme.palette.divider,
                },
                '&:not(:last-of-type)': {
                  borderBottom: '1px solid',
                  borderBottomColor: theme.palette.divider,
                },
                alignItems: 'flex-start',
                color: theme.palette.text.primary,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                padding: theme.spacing(1, 2),
                textDecoration: 'none',
                transition: 'all .2s ease',
                width: '100%',
              }}
            >
              <span css={{ fontWeight: theme.typography.fontWeightMedium }}>{file.name}</span>
              <span css={{ ...theme.typography.caption }}>{file.description}</span>
            </a>
          </span>
        )}
      </ClassNames>
    )
  };

export default DownloadsItems;